<template>
  <div>
    <div>
      <div>
        <div class="row q-gutter-sm">
          <q-select
            v-model="displayType"
            class="col-6"
            label="Display Type"
            :options="$mh.asOptions(displayTypeOptions)"
            map-options
            emit-value
            bottom-slots
          />
        </div>
        <div
          class="row q-gutter-sm q-mb-sm"
        >
          <q-input
            :model-value="displayUrl"
            class="col"
            label="Display URL"
            :readonly="displayType !== DISPLAY_TYPES.CUSTOM"
            @update:model-value="value => $emit('url-changed', value)"
          />
          <q-btn
            v-if="urlRestartEnabled"
            :disable="!urlCanRestart"
            class="col-auto"
            icon="refresh"
            @click="$emit('restart-display')"
          />
          <q-tooltip>
            Restart the web browser on the remote display
          </q-tooltip>
        </div>
        <iframe
          v-if="showPreview"
          :style="displayRotationIndex % 2 ? 'width: 300px; height: 533px;' : 'width: 100%; height: 300px;'"
          :src="displayUrl"
        />
        <div
          v-if="displayType === DISPLAY_TYPES.MEDIA"
          class="q-mb-md"
        >
          <div class="row q-col-gutter-sm items-start q-mb-sm">
            <q-checkbox
              v-model="urlProperties.displayMedia"
              label="Display Media Classes"
              class="col-6"
            />
            <q-select
              v-if="urlProperties.displayMedia"
              v-model="urlProperties.mediaClassId"
              class="col-6"
              label="Override Media Class"
              :options="signageMediaClasses.data"
              map-options
              option-label="name"
              option-value="id"
              emit-value
              bottom-slots
              clearable
            />
          </div>
          <div class="row q-col-gutter-sm items-start q-mb-sm">
            <q-checkbox
              v-model="urlProperties.displayTrailers"
              label="Display Movie Trailers"
              class="col-6"
            />
            <q-select
              v-if="urlProperties.displayTrailers"
              v-model="urlProperties.titleClassId"
              class="col-6"
              label="Override Title Class"
              :options="titleClasses.data"
              map-options
              option-label="name"
              option-value="id"
              clearable
              emit-value
              bottom-slots
            />
          </div>
          <div class="row q-mb-lg">
            <q-input
              v-model="urlProperties.defaultDisplayDuration"
              type="number"
              class="col-6"
              label="Default Display Duration (Seconds)"
              :rules="[val => !!val || 'Field is required']"
              bottom-slots
            />
          </div>
          <div class="row q-col-gutter-sm items-start q-mb-sm">
            <q-checkbox
              v-model="urlProperties.displayFooter"
              label="Display Footer"
              class="col-4"
            />
            <q-checkbox
              v-if="urlProperties.displayFooter"
              v-model="urlProperties.displayTime"
              label="Display Time"
              class="col-4"
            />
            <q-checkbox
              v-model="urlProperties.displayMessages"
              label="Display Messages"
              class="col-4"
            />
          </div>
          <div class="row q-col-gutter-sm items-start q-mb-md">
            <q-checkbox
              v-model="urlProperties.displayMovieBanners"
              label="Display Movie Banners"
              class="col-4"
            />
            <q-checkbox
              v-model="urlProperties.displayMoviePosters"
              label="Display Movie Posters"
              class="col-4"
            />
            <q-checkbox
              v-model="urlProperties.displayAnimatedPosters"
              label="Display Animated Posters"
              class="col-4"
            />
          </div>
          <div class="row q-mb-lg">
            <q-checkbox
              v-model="urlProperties.muted"
              label="Audio Muted"
              class="col-4"
            />

            <q-checkbox
              v-if="includeMediaButton"
              v-model="urlProperties.displayButton"
              label="Display Button"
              class="col-4"
            />
          </div>
          <div class="row justify-center items-center q-mb-lg">
            <div class="col-4">
              Media Background Color:
            </div>
            <q-btn
              :color="urlProperties.mediaBackgroundColor"
              glossy
              unelevated
              :style="'background-color: ' + urlProperties.mediaBackgroundColor"
              size="lg"
              class="col-7"
            >
              <div class="text-caption text-weight-light">
                <div class="text-capitalize">
                  {{ urlProperties.mediaBackgroundColor }}
                </div>
              </div>
              <q-menu
                anchor="top left"
                self="top left"
              >
                <q-color v-model="urlProperties.mediaBackgroundColor" />
              </q-menu>
            </q-btn>
          </div>
          <div
            v-if="urlProperties.displayFooter"
            class="row justify-center items-center q-mb-md"
          >
            <div class="col-4">
              Footer Background Color:
            </div>
            <q-btn
              :color="urlProperties.footerBackgroundColor"
              glossy
              unelevated
              :style="'background-color: ' + urlProperties.footerBackgroundColor"
              size="lg"
              class="col-7"
            >
              <div class="text-caption text-weight-light">
                <div class="text-capitalize">
                  {{ urlProperties.footerBackgroundColor }}
                </div>
              </div>
              <q-menu
                anchor="top left"
                self="top left"
              >
                <q-color v-model="urlProperties.footerBackgroundColor" />
              </q-menu>
            </q-btn>
          </div>
          <div
            v-if="urlProperties.displayMessages || urlProperties.displayButton"
            class="row justify-center items-center q-mb-md"
          >
            <div class="col-4">
              Caption Text Color:
            </div>
            <q-btn
              :color="urlProperties.footerTextColor"
              glossy
              unelevated
              :style="'background-color: ' + urlProperties.footerTextColor"
              size="lg"
              class="col-7"
            >
              <div class="text-caption text-weight-light">
                <div class="text-capitalize">
                  {{ urlProperties.footerTextColor }}
                </div>
              </div>
              <q-menu
                anchor="top left"
                self="top left"
              >
                <q-color v-model="urlProperties.footerTextColor" />
              </q-menu>
            </q-btn>
          </div>
          <div
            v-if="urlProperties.displayMessages || urlProperties.displayButton"
            class="row justify-center items-center q-mb-md"
          >
            <div class="col-4">
              Caption Background Color:
            </div>
            <q-btn
              :color="urlProperties.messageBackgroundColor"
              glossy
              unelevated
              :style="'background-color: ' + urlProperties.messageBackgroundColor"
              size="lg"
              class="col-7"
            >
              <div class="text-caption text-weight-light">
                <div class="text-capitalize">
                  {{ urlProperties.messageBackgroundColor }}
                </div>
              </div>
              <q-menu
                anchor="top left"
                self="top left"
              >
                <q-color v-model="urlProperties.messageBackgroundColor" />
              </q-menu>
            </q-btn>
          </div>
        </div>
      </div>

      <div
        v-if="displayType !== DISPLAY_TYPES.MEDIA && displayType !== DISPLAY_TYPES.CUSTOM"
        class="row q-col-gutter-sm items-start q-mb-sm"
      >
        <q-input
          v-model="urlProperties.marginVertical"
          label="Margin Vertical (px)"
          type="number"
          :rules="[val => val !== null && val !== '' || 'Field Required']"
        />
        <q-input
          v-model="urlProperties.marginHorizontal"
          label="Margin Horizontal (px)"
          type="number"
          :rules="[val => val !== null && val !== '' || 'Field Required']"
        />
        <q-checkbox
          v-if="useMPAFilmRatingsSymbol"
          v-model="urlProperties.highlightRRated"
          label="Highlight R Rated Badge"
        />
        <q-checkbox
          v-model="urlProperties.disableOfficialSymbol"
          label="Show Rating Without Official Symbol"
        />
      </div>

      <div
        v-if="displayType === DISPLAY_TYPES.SITE_2"
        class="row q-col-gutter-sm items-start q-mb-md"
      >
        <q-item-label>Showtime Font Size Adjustment</q-item-label>
        <q-slider
          v-model="urlProperties.showtimeFontMultiplier"
          label="Showtime Font Size"
          type="number"
          :min="50"
          :max="150"
          :step="1"
        />
      </div>
      <div
        v-if="isShowingsSlidesSignage"
        class="row q-col-gutter-sm items-start q-mb-md"
      >
        <q-input
          v-if="displayType === DISPLAY_TYPES.SITE_2"
          v-model="urlProperties.moviesPerPage"
          label="Movies Per Page"
          type="number"
          :rules="[val => !!val || 'Field Required']"
        />
        <div
          v-else-if="displayType !== DISPLAY_TYPES.SHOWINGS_BANNER"
          class="col-4"
        >
          <q-item-label>Movies Per Page</q-item-label>
          <q-slider
            v-model="urlProperties.moviesPerPage"
            label
            label-always
            switch-label-side
            type="number"
            :min="2"
            :max="6"
            :step="1"
            @update:model-value="changeCount++"
          />
        </div>

        <q-input
          v-if="displayType !== DISPLAY_TYPES.SITE"
          v-model="urlProperties.interval"
          label="Interval (ms)"
          type="number"
          :rules="[val => !!val || 'Field Required']"
          class="col"
        />
        <q-select
          v-if="displayType !== DISPLAY_TYPES.SITE"
          v-model="urlProperties.mode"
          :options="SITE_2_MODE_OPTIONS"
          label="Display Mode"
          class="col"
        />
        <template v-if="displayType === DISPLAY_TYPES.SITE_2">
          <q-checkbox
            v-model="urlProperties.compactShowingTimes"
            label="Compact Showtimes"
          >
            <q-tooltip>Enables showtimes to display as a carousel with a maximum amount of times displayed at once</q-tooltip>
          </q-checkbox>
          <q-input
            v-if="urlProperties.compactShowingTimes"
            v-model="urlProperties.compactShowingLength"
            label="Maximum Showing Times"
            type="number"
            :rules="[val => !!val || 'Field Required']"
          >
            <q-tooltip>The maximum number of showtimes to display, when number of times are greater than this number - they are displayed as a carousel</q-tooltip>
          </q-input>
          <q-input
            v-if="urlProperties.compactShowingTimes"
            v-model="urlProperties.compactShowingInterval"
            label="Showtime Change Interval (ms)"
            type="number"
            :rules="[val => !!val || 'Field Required']"
          >
            <q-tooltip>How often (in milliseconds) the carousel switches to the next batch of times for the showing</q-tooltip>
          </q-input>
        </template>
        <q-checkbox
          v-model="urlProperties.displayShowingBadges"
          label="Display Showing Badges"
        >
          <q-tooltip>Displays showing badges associated with the showtime.</q-tooltip>
        </q-checkbox>
      </div>

      <div
        class="row q-col-gutter-sm items-start q-mb-md"
      >
        <q-checkbox
          v-if="displayType === DISPLAY_TYPES.SHOWINGS_BANNER || displayType === DISPLAY_TYPES.SHOWINGS_POSTER"
          v-model="urlProperties.cleanImage"
          label="Clean Image"
        />
        <q-checkbox
          v-if="displayType === DISPLAY_TYPES.SHOWINGS_BANNER"
          v-model="urlProperties.showAllAvailableShowtimes"
          label="Show All Available Showtimes"
        />
        <q-checkbox
          v-if="displayType !== DISPLAY_TYPES.SCREEN_PORTRAIT_STATUS_STREAM"
          v-model="urlProperties.hidePast"
          label="Hide Past Showtimes"
        />
        <q-checkbox
          v-if="displayType === DISPLAY_TYPES.SHOWINGS_LIST"
          v-model="urlProperties.showingsHidePoster"
          label="Showings Hide Poster Image"
        />
      </div>

      <div
        v-if="isScreenSignage"
        class="row q-col-gutter-sm items-start q-mb-sm"
      >
        <q-select
          v-model="urlProperties.screenId"
          class="col-6"
          label="Screen"
          :options="screens.data"
          map-options
          option-label="name"
          option-value="id"
          emit-value
          bottom-slots
          :rules="[val => val !== null || 'Screen Must Be Specified']"
        />
        <q-checkbox
          v-if="displayType === DISPLAY_TYPES.SCREEN_PORTRAIT"
          v-model="urlProperties.detail"
          label="Show All Showtimes"
        />
        <q-checkbox
          v-if="displayType === DISPLAY_TYPES.SCREEN || displayType === DISPLAY_TYPES.SCREEN_PORTRAIT"
          v-model="urlProperties.moreBefore"
          label="More Before"
        />
        <q-checkbox
          v-if="displayType === DISPLAY_TYPES.SCREEN || displayType === DISPLAY_TYPES.SCREEN_PORTRAIT"
          v-model="urlProperties.moreAfter"
          label="More After"
        />
        <q-checkbox
          v-if="displayType !== DISPLAY_TYPES.SCREEN"
          v-model="urlProperties.showLogo"
          label="Show Logo"
        />
        <q-checkbox
          v-model="urlProperties.showScreenName"
          label="Show Screen Name"
        />
        <q-checkbox
          v-model="urlProperties.showRatingReason"
          label="Show Rating Reason"
        />
        <q-checkbox
          v-model="urlProperties.showMovieName"
          label="Show Movie Name"
        />
        <q-checkbox
          v-model="urlProperties.showShowingBadges"
          label="Show Showing Badges"
        />
        <q-checkbox
          v-if="displayType === DISPLAY_TYPES.SCREEN_PORTRAIT_STATUS_STREAM"
          v-model="urlProperties.posterShowBorder"
          label="Display Border Around Poster Image"
        />
        <q-checkbox
          v-if="displayType === DISPLAY_TYPES.SCREEN_PORTRAIT_STATUS_STREAM"
          v-model="urlProperties.showMotionPoster"
          label="Display Motion Poster"
        >
          <q-tooltip>If There is One</q-tooltip>
        </q-checkbox>
        <q-input
          v-if="displayType === DISPLAY_TYPES.SCREEN_PORTRAIT_STATUS_STREAM"
          v-model="urlProperties.showingStatusFontSize"
          class="col-3 q-pr-sm q-pb-sm"
          label="Showing Status Font Size"
          type="number"
        />
        <div
          v-if="displayType === DISPLAY_TYPES.SCREEN_PORTRAIT_STATUS_STREAM"
          class="col-3 q-pr-sm q-pb-sm"
        >
          <q-item-label>Poster Border Radius</q-item-label>
          <q-slider
            v-model="urlProperties.posterBorderRadius"
            label
            label-always
            switch-label-side
            type="number"
            :min="0"
            :max="10"
            :step="14"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { isNARegion, region } from 'src/config'
import { DISPLAY_TYPES, getDisplayType, urlToProperties } from 'src/models/signage/SignageUrlBuilder'

const MEDIA_ARGUEMENTS = ['displayMedia', 'displayTrailers', 'displayFooter', 'displayMessages',
  'titleClassId', 'muted', 'mediaClassId', 'displayMovieBanners', 'displayMoviePosters', 'displayAnimatedPosters',
  'footerBackgroundColor', 'mediaBackgroundColor', 'messageBackgroundColor', 'defaultDisplayDuration',
  'displayTime', 'footerTextColor', 'hasLink', 'displayButton']
const SITE_ARGUEMENTS = ['marginHorizontal', 'marginVertical', 'cover', 'hidePast', 'highlightRRated', 'disableOfficialSymbol']
const SITE_2_ARGUEMENTS = [...SITE_ARGUEMENTS, ...['mode', 'moviesPerPage', 'interval', 'compactShowingTimes', 'compactShowingLength', 'compactShowingInterval', 'showtimeFontMultiplier', 'displayShowingBadges']]
const SHOWINGS_POSTER_ARGUEMENTS = [...SITE_ARGUEMENTS, ...['showLogo', 'mode', 'moviesPerPage', 'interval', 'cleanImage', 'displayShowingBadges']]
const SCREEN_ARGUEMENTS = [...SITE_ARGUEMENTS, ...['showShowingBadges', 'showScreenName', 'showRatingReason', 'showMovieName', 'moreBefore', 'moreAfter']]
const SCREEN_LANDSCAPE_ARGUEMENTS = [...SITE_ARGUEMENTS, ...['showLogo', 'showScreenName', 'showRatingReason', 'showMovieName', 'showShowingBadges']]
const SCREEN_LANDSCAPE_POSTER_LEFT_ARGUEMENTS = [...SITE_ARGUEMENTS, ...['showLogo', 'showScreenName', 'showRatingReason', 'showMovieName', 'showShowingBadges']]
const SHOWINGS_BANNER_ARGUEMENTS = [...SITE_ARGUEMENTS, ...['mode', 'showLogo', 'interval', 'cleanImage', 'showAllAvailableShowtimes', 'showMovieName', 'displayShowingBadges']]
const SCREEN_PORTRAIT_ARGUEMENTS = [...SITE_ARGUEMENTS, ...['showLogo', 'showScreenName', 'showRatingReason', 'showMovieName', 'showShowingBadges', 'detail', 'moreBefore', 'moreAfter']]
const SCREEN_PORTRAIT_STATUS_STREAM_ARGUEMENTS = ['marginHorizontal', 'marginVertical', 'showLogo', 'showScreenName', 'showRatingReason', 'showMovieName', 'showShowingBadges', 'posterShowBorder', 'posterBorderRadius', 'showMotionPoster', 'showingStatusFontSize', 'highlightRRated', 'disableOfficialSymbol']
const SITE_PORTRAIT_ARGUEMENTS = SITE_ARGUEMENTS
const SHOWINGS_LIST_ARGUEMENTS = [...SITE_ARGUEMENTS, ...['mode', 'showLogo', 'moviesPerPage', 'interval', 'showingsHidePoster', 'displayShowingBadges']]

const SITE_2_MODE_OPTIONS = ['page', 'cycle']

const ARGUEMENTS = {
  [DISPLAY_TYPES.MEDIA]: MEDIA_ARGUEMENTS,
  [DISPLAY_TYPES.SITE]: SITE_ARGUEMENTS,
  [DISPLAY_TYPES.SITE_2]: SITE_2_ARGUEMENTS,
  [DISPLAY_TYPES.SHOWINGS_POSTER]: SHOWINGS_POSTER_ARGUEMENTS,
  [DISPLAY_TYPES.SITE_PORTRAIT]: SITE_PORTRAIT_ARGUEMENTS,
  [DISPLAY_TYPES.SHOWINGS_BANNER]: SHOWINGS_BANNER_ARGUEMENTS,
  [DISPLAY_TYPES.SHOWINGS_LIST]: SHOWINGS_LIST_ARGUEMENTS,
  [DISPLAY_TYPES.SCREEN]: SCREEN_ARGUEMENTS,
  [DISPLAY_TYPES.SCREEN_LANDSCAPE]: SCREEN_LANDSCAPE_ARGUEMENTS,
  [DISPLAY_TYPES.SCREEN_PORTRAIT]: SCREEN_PORTRAIT_ARGUEMENTS,
  [DISPLAY_TYPES.SCREEN_PORTRAIT_STATUS_STREAM]: SCREEN_PORTRAIT_STATUS_STREAM_ARGUEMENTS,
  [DISPLAY_TYPES.SCREEN_LANDSCAPE_POSTER_LEFT]: SCREEN_LANDSCAPE_POSTER_LEFT_ARGUEMENTS
}

export default {
  name: 'SignageBuilder',
  props: {
    displayUrl: {
      type: String,
      required: true
    },
    displayRotationIndex: {
      type: Number,
      required: false,
      default: 0
    },
    urlRestartEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
    urlCanRestart: {
      type: Boolean,
      required: false,
      default: false
    },
    showPreview: {
      type: Boolean,
      required: false,
      default: true
    },
    excludeScreens: {
      type: Boolean,
      required: false,
      default: false
    },
    includeMediaButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['url-changed', 'restart-display'],
  data () {
    return {
      loadingAction: null,
      displayType: DISPLAY_TYPES.CUSTOM,
      customUrl: '',
      urlProperties: {
        displayMedia: true,
        displayTrailers: true,
        displayFooter: false,
        displayMessages: false,
        titleClassId: null,
        muted: false,
        mediaClassId: null,
        marginHorizontal: DISPLAY_TYPES.SCREEN_PORTRAIT_STATUS_STREAM ? 100 : 0,
        marginVertical: 0,
        cover: false,
        mode: null,
        moviesPerPage: 4,
        interval: 5000,
        screenId: null,
        moreBefore: false,
        moreAfter: false,
        displayMovieBanners: false,
        displayMoviePosters: false,
        displayAnimatedPosters: false,
        footerBackgroundColor: '#ffffff',
        mediaBackgroundColor: '#000000',
        messageBackgroundColor: '#AAAAAA',
        defaultDisplayDuration: 5,
        displayTime: false,
        footerTextColor: '#191c5e',
        showLogo: true,
        showScreenName: this.displayType === DISPLAY_TYPES.SCREEN_LANDSCAPE_POSTER_LEFT || this.displayType === DISPLAY_TYPES.SCREEN_PORTRAIT || this.displayType === DISPLAY_TYPES.SCREEN_PORTRAIT_STATUS_STREAM,
        hidePast: false,
        compactShowingTimes: false,
        compactShowingLength: 6,
        compactShowingInterval: 5000,
        showtimeFontMultiplier: 100,
        showRatingReason: true,
        displayShowingBadges: false,
        cleanImage: false,
        detail: false,
        showingsHidePoster: false,
        showAllAvailableShowtimes: false,
        showMovieName: true,
        showShowingBadges: true,
        hasLink: false,
        displayButton: false,
        posterShowBorder: true,
        posterBorderRadius: 2,
        showMotionPoster: true,
        showingStatusFontSize: 4,
        highlightRRated: false,
        disableOfficialSymbol: false
      }
    }
  },
  computed: {
    propValues () {
      return Object.values(this.urlProperties)
    },
    currentDisplayTypeAvailableArguements () {
      return ARGUEMENTS[this.displayType]
    },
    displayTypeOptions () {
      if (!this.excludeScreens) return Object.values(DISPLAY_TYPES.ALL)

      return _.filter(Object.values(DISPLAY_TYPES.ALL), (key, val) => !key.includes('screen'))
    },
    isShowingsSlidesSignage () {
      const showingsSlidsSignage = [DISPLAY_TYPES.SITE_2, DISPLAY_TYPES.SHOWINGS_POSTER, DISPLAY_TYPES.SHOWINGS_BANNER, DISPLAY_TYPES.SHOWINGS_LIST]

      return _.includes(showingsSlidsSignage, this.displayType)
    },
    isScreenSignage () {
      const screenSignage = [DISPLAY_TYPES.SCREEN, DISPLAY_TYPES.SCREEN_LANDSCAPE, DISPLAY_TYPES.SCREEN_PORTRAIT, DISPLAY_TYPES.SCREEN_LANDSCAPE_POSTER_LEFT, DISPLAY_TYPES.SCREEN_PORTRAIT_STATUS_STREAM]

      return _.includes(screenSignage, this.displayType)
    },
    useMPAFilmRatingsSymbol () {
      return isNARegion
    }
  },
  watch: {
    propValues () {
      this.$emit('url-changed', this.buildUrl())
    },
    'displayType' () {
      this.$emit('url-changed', this.buildUrl())

      if (this.displayType === DISPLAY_TYPES.SCREEN_LANDSCAPE_POSTER_LEFT || this.displayType === DISPLAY_TYPES.SCREEN_PORTRAIT || this.displayType === DISPLAY_TYPES.SCREEN_PORTRAIT_STATUS_STREAM) {
        this.urlProperties.showScreenName = true
      }
      if (this.displayType === DISPLAY_TYPES.SCREEN_PORTRAIT_STATUS_STREAM) {
        this.urlProperties.marginHorizontal = 100
      } else {
        this.urlProperties.marginHorizontal = 0
      }
    },
    displayUrl () {
      this.parseUrl()
      this.customUrl = this.displayUrl
    },
    customUrl () {
      this.$emit('url-changed', this.customUrl)
    }
  },
  mounted () {
    this.parseUrl()
  },
  created () {
    _.extend(this, { DISPLAY_TYPES, region, SITE_ARGUEMENTS, SITE_2_ARGUEMENTS, SCREEN_ARGUEMENTS, SITE_2_MODE_OPTIONS })
  },
  methods: {
    buildUrl () {
      let baseUrl
      let route = ''
      const arguements = []

      if (process.env.DEV) {
        baseUrl = 'http://indy.local:8083'
      } else {
        baseUrl = `https://signage-${region}.indy.systems`
      }

      if (this.displayType === DISPLAY_TYPES.CUSTOM) {
        return 'https://google.com'
      }

      if (this.displayType) {
        route = `/${this.displayType}/${this.isScreenSignage ? this.urlProperties.screenId : this.currentSite.id}`
      }

      _.each(this.currentDisplayTypeAvailableArguements, arguement => {
        const value = this.urlProperties[arguement]
        if (value !== null) {
          arguements.push(`${arguement.replace(/[A-Z]/g, m => '-' + m.toLowerCase())}=${encodeURIComponent(value)}`)
        }
      })

      const formattedArguements = arguements.length > 0 ? '?' + arguements.join('&') : ''

      return baseUrl + route + formattedArguements
    },
    parseUrl () {
      if (!this.displayUrl) return
      const currentRoute = getDisplayType(this.displayUrl)
      if (currentRoute) {
        this.displayType = currentRoute
      }
      const existingProperties = urlToProperties(this.displayUrl)

      if (existingProperties === null) {
        this.buildUrl()
      } else {
        _.each(existingProperties, prop => { this.urlProperties[prop.key] = prop.value })
      }
    }
  },
  configuration: ['currentSite', 'screens', 'titleClasses', 'signageMediaClasses']
}

</script>
